<template>
  <div class="wrapper">
      <!-- <Toast style="margin-top: 35px" /> -->
        <div id="formContent" class="fadeIn">
            <!-- Tabs Titles -->
            <div class="tabs">
              <router-link to="/login"> <h2 class="inactive">Log In</h2></router-link>
              <h2 class="active">Inquiry</h2>
            </div>

            <form id="inquiryForm" class="formInit">
                <div class="wrap-input1 validate-input" data-validate = "Name is required">
                    <input class="fadeIn " type="text" v-model="name" placeholder="Name">
                    <span class="shadow-input1"></span>
                </div>
                <div class="wrap-input1 validate-input" data-validate = "Valid email is required: ex@abc.xyz">
                    <input class="input1" type="text" v-model="email" placeholder="Email">
                    <span class="shadow-input1"></span>
                </div>

                <div class="wrap-input1">
                    <input class="input1" type="text" v-model="company" placeholder="Company name">
                    <span class="shadow-input1"></span>
                </div>

                <div class="wrap-input1 validate-input" data-validate = "Phone number is required: 9800xxx">
                    <input class="input1" type="text" v-model="phone" placeholder="Phone number">
                    <span class="shadow-input1"></span>
                </div>

                <div class="wrap-input1 validate-input" data-validate = "Subject is required">
                    <input class="input1" type="text" v-model="subject" placeholder="Subject">
                    <span class="shadow-input1"></span>
                </div>

                <div class="wrap-input1 validate-input" data-validate = "Message is required">
                    <textarea class="input1" v-model="message" placeholder="Message"></textarea>
                    <span class="shadow-input1"></span>
                </div>

                <div class="container-contact1-form-btn">
                    <button class="btnItm" @click.prevent="sendInquiry">
                        <span>
                            Send
                            <!-- <i class="fa fa-long-arrow-right" aria-hidden="true"></i> -->
                        </span>
                    </button>
                </div>
            </form>

            <div id="formFooter">
                <span class="underlineHover">Powered by</span>
                <span> <a href="https://raisetech.com.np" target="_blank"><img src="static/img/raiseTechlogo.png"  alt="Raiselogo" class="img-fluid"/></a> </span>
            </div>
        </div>
  </div>
</template>
<script>
// import Toast from 'primevue/toast'
export default {
  name: 'Inquiry',
  data() {
    return {
      name: '',
      email: '',
      phone: '',
      message: '',
      company: '',
      subject: ''
    }
  },
  methods: {
    async sendInquiry() {
      let inquiryData = {
        name: this.name,
        email: this.email,
        phoneNumber: this.phone,
        message: this.message,
        companyName: this.company,
        subject: this.subject
      }
      let response = await this.$store.dispatch('sendInquiry', inquiryData)
      if (response.data.status === 'SUCCESS') {
        this.$toast.add({severity: 'success', summary: '', detail: response.data.message, life: 10000})
      }
      this.reset()
    },
    reset() {
      this.name = ''
      this.email = ''
      this.phone = ''
      this.message = ''
      this.company = ''
      this.subject = ''
    }
  },
  components: {
    // Toast
  }
}
</script>
<style scoped  src="@../../../static/css/loginpage.css">
</style>



// WEBPACK FOOTER //
// inquiry.vue?59f3ae92